// StatisticaBenefits.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { Headers, Row, getTotal, Total } from './helpers/table';
import { getPeriods, getListBenefits } from './actions/statistics';
import { ageCategory, ageCategoryKitchen, benefitCategory, shortnames, shortnames_kitch, schema } from './constants/benefits';
import { getArrPeriods, getBenefitsLists, convData, convDataKitchen } from './helpers/benefitsHelpers';
import BenefitsFilters from './componenets/BenefitsFilters';
import './StatisticaBenefits.css';

const { benefits_kg, benefits_kitch } = getBenefitsLists(shortnames, shortnames_kitch);

const StatisticaBenefits = () => {
  const periods = getArrPeriods();
  
  const [info, setInfo] = useState([]);
  const [years, setYears] = useState([]);
  const [distr, setDistr] = useState([]);
  const [schemaTable, setSchemaTable] = useState([...schema]);
  const [total, setTotal] = useState({});
  
  const [selYear, setSelYear] = useState('');
  const [selDist, setSelDist] = useState('');
  const [selAge, setSelAge] = useState(ageCategory[ageCategory.length - 1].v);
  const [selCategory, setSelCategory] = useState(benefitCategory[0].v);
  const [period, setPeriod] = useState(periods[0]);
  const [selPilgaKg, setSelPilgaKg] = useState(benefits_kg[0]?.id || '');

  const setInfoData = useCallback((data) => {
    const { schema_f, data_c } = selCategory === 'kg' ? convData(data) : convDataKitchen(data);
    const allschema = [...schema, ...schema_f];
    
    setInfo(data_c);
    setSchemaTable(allschema);
    setTotal(getTotal(data_c, allschema));
  }, [selCategory]);

  const handleGetInfo = useCallback(() => {
    const yearValue = selYear.split(":")[0];
    
    getListBenefits({
      district: selDist, 
      periodStartYear: yearValue,
      area: selCategory, 
      age: selAge,
      benefit: selPilgaKg,
      period 
    }, setInfoData, (err) => alert(`Помилка при отриманні даних`));
  }, [selDist, selYear, selCategory, selAge, selPilgaKg, period, setInfoData]);

  const handleSetYear = useCallback((e) => {
    const info = e.target.value.split(':');
    const yearIndex = parseInt(info[1]);
    
    if (years[yearIndex]) {
      let countSol = 0;
      let distrList = [];

      years[yearIndex].dist.forEach((item) => {
        if (item.match(/Со/) && countSol === 0) {
          countSol += 1;
          distrList.push('Солом\'янський');
        } else {
          distrList.push(item);
        }
      });

      setDistr(distrList.sort());
      setSelYear(e.target.value);
      setSelDist(distrList.sort()[0]);
    }
  }, [years]);

  useEffect(() => {
    getPeriods(false, (cursor) => {
      const sortedCurs = cursor.sort((a, b) => {
        if (a._id > b._id) return -1;
        if (a._id < b._id) return 1;
        return 0;
      });

      setYears(sortedCurs);
      setDistr(sortedCurs[0]?.dist || []);
      setSelYear(sortedCurs[0]?._id + ':0' || '');
      setSelDist(sortedCurs[0]?.dist?.sort()[0] || '');
    }, (err) => alert(`Помилка при отриманні даних щодо груп ${JSON.stringify(err)}`));
  }, []);

  return (
    <div className="benefits-container pilgi-statistic">
      <BenefitsFilters
        years={years}
        distr={distr}
        selYear={selYear}
        selDist={selDist}
        selCategory={selCategory}
        selAge={selAge}
        selPilgaKg={selPilgaKg}
        period={period}
        periods={periods}
        onYearChange={handleSetYear}
        onDistrictChange={(e) => setSelDist(e.target.value)}
        onCategoryChange={(e) => setSelCategory(e.target.value)}
        onAgeChange={(e) => setSelAge(e.target.value)}
        onBenefitChange={(e) => setSelPilgaKg(e.target.value)}
        onPeriodChange={(e) => setPeriod(e.target.value)}
        onShowData={handleGetInfo}
      />
      
      { (info?.length > 0) && <div className="tableFixHead table-responsive">
        <table className="table table-striped" id='tableMainInfoGroupForCopy'>
          <thead>
            <Headers schema={schemaTable}/>
          </thead>
          <tbody>
            {info.map((el, index) => <Row key={index} schema={schemaTable} d={el}/>)}
            <Total schema={schemaTable} total={total}/>
          </tbody>
        </table>
      </div>}
    </div>
  );
};

export default StatisticaBenefits;